'use client';

import { CheckmarkIcon, CloseIcon } from '@kohler-dsm-library/kohler-icons';
import { buildDsmImageProps } from '@/aem-dsm-mappers/utils/imageProps';
import './comparisonTable.css';

export default function ComparisonTable({ columns, rows, heading }) {
  return (
    <div className="comparison-wrapper">
      <h2>{heading}</h2>

      {/* Desktop Table */}
      <table className="desktop-table">
        <thead>
          <tr>
            <th>
              <div className="th-content">
                <div></div>
              </div>
            </th>
            {columns.map((col, idx) => (
              <th
                key={idx}
                style={{
                  width: `${(100 - 28) / columns.length}%`,
                }}
              >
                <div className="th-content">
                  {col.imageRef && (
                    <img
                      {...buildDsmImageProps({
                        src: col.imageRef,
                        alt: col.label,
                        allowEmptySrc: false,
                      })}
                    />
                  )}
                  <div>{col.label}</div>
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rIdx) => (
            <tr key={rIdx}>
              <td>{row.rowLabel}</td>

              {row.values.map((val, vIdx) => (
                <td key={vIdx}>{val.bool ? <CheckmarkIcon /> : ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile Layout */}
      <div className="mobile-view">
        {columns.map((col, cIdx) => (
          <div key={cIdx} className="product-card">
            <h3>{col.label}</h3>

            <div className="card-image">
              <img
                {...buildDsmImageProps({
                  src: col.imageRef,
                  alt: col.label,
                  allowEmptySrc: true,
                })}
              />
            </div>

            <ul>
              {rows.map((row, rIdx) => (
                <li key={rIdx}>
                  <span className="card-label">{row.rowLabel}</span>
                  <span className={`card-icon ${row.values[cIdx]?.bool ? 'true' : 'false'}`}>
                    {row.values[cIdx]?.bool ? <CheckmarkIcon /> : <CloseIcon />}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
